import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useAddClient = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.ADD_CLIENT],
    (data) => ApiService.addClient(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_CLIENT_LIST);
        setShowAddForm(false);
        toast.success("Customer added successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useAddClient;
